// extracted by mini-css-extract-plugin
export default {"visually-hidden":"LogOutHeaderMenu_visually-hidden__9FhUd","accLogo":"LogOutHeaderMenu_accLogo__lvUv1","logout__button":"LogOutHeaderMenu_logout__button__+iib8"};